/**
 * Checks if the specified storage (localStorage or sessionStorage) is available and can be written to.
 * @params {string} type - The storage type to check ('localStorage' or 'sessionStorage').
 * @params {string} [value=''] - The value to test with; defaults to an empty string.
 * @returns {boolean} True if the storage is available, false otherwise.
 * */
const isStorageAvailable = (type, value = '') => {
  try {
    const storage = window[type];
    const testKey = '__storage_test__';
    storage.setItem(testKey, value || testKey);
    storage.removeItem(testKey);
    return true;
  } catch (e) {
    return (
      e instanceof DOMException &&
      (e.name === 'QuotaExceededError' ||
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED')
    );
  }
};

export default isStorageAvailable;
